import React from 'react';
import ReactDOM from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
// import { ThemeProvider } from '@/lib/context/ThemeContext';
import './index.css';
import NotFound from './pages/Error/404';

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://fee0bbe718a08b8d43b5d5da242395ac@sentry-instance.theralink.us/9",
});

type PageComponent = React.ComponentType<any> & {
  layout?: React.ComponentType<any>;
};

const pages = import.meta.glob<{ default: PageComponent }>("./pages/**/*.tsx");

// document.addEventListener("DOMContentLoaded", () => {
  createInertiaApp({
    resolve: async (name) => {
      try {
        const page = (await pages[`./pages/${name}.tsx`]()).default;
        return page;
      } catch (error) {
        console.error(`Failed to resolve page: ${name}`, error);
        return NotFound;
      }
    },
    setup({ el, App, props }) {
      const root = ReactDOM.createRoot(el);
      root.render(
        <React.StrictMode>
          {/* <ThemeProvider> */}
            <App {...props} />
          {/* </ThemeProvider> */}
        </React.StrictMode>
      );
    },
  });
// });


